export const LOCAL_STORAGE_SHINY_EFFECT = 'LOCAL_STORAGE_SHINY_EFFECT_{}_{}_{}';
export const LOCAL_STORAGE_COUNT_ALL_BUNDLES = 'LOCAL_STORAGE_COUNT_ALL_BUNDLES';
export const LOCAL_STORAGE_LABELS = 'LOCAL_STORAGE_LABELS_{}';
export const LOCAL_STORAGE_ACTIVATE_ACCOUNT_POPUP = 'LOCAL_STORAGE_ACTIVATE_ACCOUNT_POPUP_{}';
export const LOCAL_STORAGE_WOWS_CLIENT_DEV = 'LOCAL_STORAGE_WOWS_CLIENT_DEV';
export const LOCAL_STORAGE_FILTER_POSITION = 'LOCAL_STORAGE_FILTER_POSITION_{}';
export const LOCAL_STORAGE_CATEGORIES_SOUNDS = 'LOCAL_STORAGE_CATEGORIES_SOUNDS_{}';
export const LOCAL_STORAGE_AUCTION_PREVIEW_LOT_VIDEO = 'LOCAL_STORAGE_AUCTION_PREVIEW_LOT_VIDEO_{}_{}';
